module.exports = __webpack_public_path__ + "media/images/consumer/components/progress-bar/step-02-7233d0a1950fca000aad25d2fe2642ec.webp";